var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6158f5284c057c61b9e3642e_Support.svg",
    clipPath: "url(#clip0_13_421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-11",
    d: "M22.5 45.6375C34.9264 45.6375 45 35.5639 45 23.1375C45 10.711 34.9264 0.637451 22.5 0.637451C10.0736 0.637451 0 10.711 0 23.1375C0 35.5639 10.0736 45.6375 22.5 45.6375Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9065 27.8561L13.6052 29.9664C13.5242 30.5349 13.7154 31.1095 14.122 31.5155C14.528 31.9222 15.1026 32.1133 15.6711 32.0323C16.3352 31.9374 17.1003 31.8272 17.7431 31.7846C17.7583 31.7834 17.7735 31.7821 17.7888 31.7797C18.5454 31.6714 19.3172 31.7243 20.0519 31.9355C20.0537 31.9355 20.0555 31.9362 20.0574 31.9368C20.8347 32.1522 21.654 32.2679 22.5001 32.2679C27.5395 32.2679 31.6305 28.1768 31.6305 23.1375C31.6305 18.0981 27.5395 14.007 22.5001 14.007C17.4607 14.007 13.3696 18.0981 13.3696 23.1375C13.3696 23.9939 13.4883 24.8235 13.7568 25.5966C13.9625 26.324 14.0148 27.097 13.9065 27.8561ZM18.8723 26.0722H22.5408C22.8783 26.0722 23.1522 25.7801 23.1522 25.4201C23.1522 25.0601 22.8783 24.7679 22.5408 24.7679H18.8723C18.5348 24.7679 18.2609 25.0601 18.2609 25.4201C18.2609 25.7801 18.5348 26.0722 18.8723 26.0722ZM18.8665 23.7896H26.1336C26.4679 23.7896 26.7392 23.4975 26.7392 23.1375C26.7392 22.7775 26.4679 22.4853 26.1336 22.4853H18.8665C18.5322 22.4853 18.2609 22.7775 18.2609 23.1375C18.2609 23.4975 18.5322 23.7896 18.8665 23.7896ZM18.8665 21.507H26.1336C26.4679 21.507 26.7392 21.2148 26.7392 20.8548C26.7392 20.4948 26.4679 20.2027 26.1336 20.2027H18.8665C18.5322 20.2027 18.2609 20.4948 18.2609 20.8548C18.2609 21.2148 18.5322 21.507 18.8665 21.507Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0 0.637451)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.b7c7cfd156da9cc366efd507829b5182.svg";
export { ForwardRef as ReactComponent };